import { useDispatch, useSelector } from "react-redux";

import { AppDispatch, RootState } from "../../store/store";

import EmployeeService, {
    EmployeeFilterType
} from "../../services/employees/EmployeeService";

import {
    loadingEmployeeDropdown
} from "../../store/slices/employees/employeeSlice";

export const useEmployee = () => {

    const dispatch: AppDispatch = useDispatch();

    const { employeeDropdown } = useSelector(
        (state: RootState) => state.employee
    );

    // =====================================================
    // 👨‍💼 Fetch Dropdown
    // =====================================================

    const fetchEmployeesDropdown = async (
        filterType: EmployeeFilterType =
            EmployeeFilterType.GENERAL
    ) => {

        try {

            const response =
                await EmployeeService.fetchDropdown(
                    filterType
                );

            dispatch(
                loadingEmployeeDropdown(
                    response
                )
            );

        } catch (error) {

            console.error(
                "❌ Error loading employees:",
                error
            );

        }

    };

    // =====================================================
    // 🔍 Helpers
    // =====================================================

    const findEmployeeById = (
        id: number
    ) => {

        return employeeDropdown.find(
            (employee) => employee.id === id
        );

    };

    // =====================================================
    // ✅ Return
    // =====================================================

    return {

        employeeDropdown,

        fetchEmployeesDropdown,

        findEmployeeById

    };

};